export const BLOG_LOCALES = ['ru', 'en'] as const;
export type BlogLocale = (typeof BLOG_LOCALES)[number];

export interface BlogPostTranslation {
  locale: string;
  slug: string;
  title: string;
  page_title: string | null;
  description: string | null;
  content: string | null;
}

export interface BlogPost {
  id: number;
  blog_category_id: number | null;
  cover_image: string | null;
  is_published: boolean;
  published_at: string | null;
  translations: BlogPostTranslation[];
}

export interface BlogPostSummary {
  id: number;
  title: string;
  is_published: boolean;
  published_at: string | null;
  cover_image: string | null;
  category: {id: number; slug: string; title: string} | null;
  locales: string[];
  updated_at: string | null;
}

export interface BlogCategoryTranslation {
  locale: string;
  title: string;
  description: string | null;
}

export interface BlogCategory {
  id: number;
  slug: string;
  sort_order: number;
  posts_count: number;
  translations: BlogCategoryTranslation[];
}

export interface SaveBlogPostPayload {
  blog_category_id: number | null;
  cover_image: string | null;
  is_published: boolean;
  published_at: string | null;
  translations: BlogPostTranslation[];
}

export interface SaveBlogCategoryPayload {
  slug: string;
  sort_order: number;
  translations: BlogCategoryTranslation[];
}
